/*
Dansko Code 2/14/2023 RDF
the base EU sizes are hidden, and using the underlying radio buttons as a data source
an overlay is created providing US size translations from hard coded arrays for men and women.
additional html/css is added to create a tabbed display, with appropriate events (hide/show).
click events are addded to the overlay, which in turn fire click events on the base tags,
keeping the underlying base structure firing it's normal events. so no data new events are added.
all events keep layers in sysnc visually, i.e., EU 35 & US similar are highlighted as required.
availability is ported to overlay and not affected
existing css styles are utilized for created overlay
display/not is determined on product.liquid => type="shoes"
mens display if size 44 exists, womens display if size 40 exists

DAN-77 QA r1 (Summer Sights 8/11): root-scoped initialiser, exposed as
window.danskoSizeTabbing.mollie(root) so the Quick Shop drawer can build the
toggle too. See the matching note in dansko_sizetabbing.js.
*/

// Size unit toggle (.size-toggle) + .not-eu styles now live in assets/theme.css (redesign).

(function () {
  function parsifalMe(s) {
    //get inty with it, if possible
    var p = parseFloat(s);
    if (isNaN(p)) {
      return 0;
    }
    return p;
  }

  function initSizeTabbing(root) {
    root = root || document;

    //base EU sizes if they exist, if not, do nothing, not now, or ever
    var baseSizeInput = root.querySelector("input[name='options[Size]']");
    if (!baseSizeInput) {
      return;
    }
    var rfneu = baseSizeInput.closest('.radio__fieldset');
    if (!rfneu) {
      return;
    }
    //if sizes container exists, if not do nothing
    var dsls = root.querySelector(".selector-wrapper[data-select-label='Size']");
    if (!dsls) {
      return;
    }
    //never build the overlay twice over the same markup (the drawer re-renders)
    if (dsls.querySelector('.size-toggle')) {
      return;
    }

    rfneu.classList.add("is-eu"); //just marking territory, may decide to use
    //hide base EU to start
    //rfneu.style.display = 'none';
    //change of plans hide US to start
    //var hneu = document.querySelectorAll('.not-eu').style.display = 'none';
    //also hide kegend even when EU sizes show
    rfneu.querySelector('.radio__legend').style.display = 'none';
    //make tabs
    var sizes = '<div class="size-toggle" data-unit="eu"><span class="radio__legend__label size-toggle__label">Select Size</span><span class="size-toggle__control"><span class="tab size-toggle__unit active">EU</span><button type="button" class="size-toggle__switch" role="switch" aria-checked="false" aria-label="Switch between EU and US sizing"><span class="size-toggle__knob"></span></button><span class="tab size-toggle__unit">US</span></span></div>';
    var iswmns = root.querySelectorAll("input[name='options[Size]'][value='40']").length;
    var w = root.querySelectorAll("input[name='options[Size]']");
    //create womens sizes if needed
    if (iswmns > 0) {
      sizes += '<fieldset class="radio__fieldset not-eu" style="display: none;"><legend class="radio__legend"><span class="radio__legend__label">Womens</span></legend>';
      var ws = ["6-6.5", "7", "7.5", "8", "8.5", "9", "9.5", "10-10.5", "11-11.5", "12"];
      sizes += '<div class="radio__inputs radio__inputs--equal">';
      var x = 0;
      w.forEach((item) => {
        var s = parsifalMe(item.value);
          if (item.classList.contains("sold-out")) {
             sizes += '<span class="radio__button"><input type="radio" class="sold-out" name="altSizeW" value="' + s + '" /><label><span>' + ws[x] + '</span></label></span>';
          } else {
             sizes += '<span class="radio__button"><input type="radio" name="altSizeW" value="' + s + '" /><label><span>' + ws[x] + '</span></label></span>';
          }
        x++;
      });
      sizes += '</div></fieldset>';
    }
    dsls.insertAdjacentHTML("afterbegin",sizes);

    /*
    DAN-67 QA r1 (Summer Sights 8/6): keep the US overlay's availability in sync
    with the base EU radios. See the matching comment in dansko_sizetabbing.js —
    the theme's SelloutVariants owns .sold-out/.unavailable and rewrites them on
    every option change, so a one-time snapshot at build time goes stale (or is
    empty, if this deferred script runs first).
    */
    function syncAltAvailability() {
      dsls.querySelectorAll(".not-eu .radio__button input[type='radio']").forEach((alt) => {
        var base = rfneu.querySelector("input[type='radio'][value='" + alt.value + "']");
        if (!base) { return; }
        ["sold-out", "unavailable"].forEach((cls) => {
          alt.classList.toggle(cls, base.classList.contains(cls));
        });
      });
    }
    syncAltAvailability();
    var availabilityObserver = new MutationObserver(syncAltAvailability);
    rfneu.querySelectorAll("input[type='radio']").forEach((base) => {
      availabilityObserver.observe(base, { attributes: true, attributeFilter: ["class"] });
    });

    var neu = rfneu.querySelector("span:nth-of-type(2)");
    /*
    DAN-77 QA r4/r5: WebKit's "rendering legend" keeps the hidden first
    <legend>'s box reserved once the fieldset was laid out with it visible, and
    only recreating the fieldset's renderer (display none → reflow → block)
    releases it — moving or removing the legend does not. The move must still
    run AFTER the `neu` capture above (that selector relies on the legend's
    value span being the second span in document order). See
    dansko_sizetabbing.js for the full note.
    */
    var baseLegend = rfneu.querySelector('.radio__legend');
    if (baseLegend) {
      rfneu.appendChild(baseLegend);
    }
    rfneu.style.display = 'none';
    void rfneu.offsetHeight; // force the teardown before showing it again
    rfneu.style.display = 'block';
    if (neu) {
      var cv = neu.innerText;
      var dv = dsls.querySelectorAll(".not-eu input[type='radio'][value='" + cv + "']");
      dv.forEach((item) => {
        item.checked = true;
      });
    }
    //US size radios & containers
    var nrb = dsls.querySelectorAll(".not-eu .radio__button");
    var nrbi = dsls.querySelectorAll(".not-eu .radio__button input[type='radio']");
    nrb.forEach((item) => {
      item.onclick = function() {
        //this value
        var vv = item.querySelector("input[type='radio']").value;
        //uncheck all not eu radios not with value
        nrbi.forEach((b) => {
          if (b.value == vv) {
            b.checked = true;
          } else {
            b.checked = false;
          }
        });
        //click it's EU doppleganger
        var l = rfneu.querySelector("input[type='radio'][value='" + vv + "']");
        l.labels[0].click();
      }
    });
    var eu = root.querySelectorAll(".product__block__variants .selector-wrapper[data-select-label='Size'] input[type='radio']");
    eu.forEach((i) => {
        i.onchange = function() {
          nrbi.forEach((b) => {
            if (b.value == i.value) {
              b.checked = true;
            } else {
              b.checked = false;
            }
            neu.innerText = i.value;
          });
        };
    });
    var tb =  dsls.querySelectorAll(".tab");
    //where is width, it should not be in here because it is not a variant, although it could be a radio__fieldset
    //this gets all button containers in size thingy
    var tbs = root.querySelectorAll(".product__block__variants .selector-wrapper[data-select-label='Size'] .radio__fieldset");
    //reflect the active unit on the toggle (knob position + a11y)
    function syncSizeToggle(unit) {
      var st = dsls.querySelector(".size-toggle");
      if (st) { st.setAttribute("data-unit", unit); }
      var sw = dsls.querySelector(".size-toggle__switch");
      if (sw) { sw.setAttribute("aria-checked", unit === "us" ? "true" : "false"); }
    }
    //tab clickery
    tb.forEach((item) => {
      item.onclick = function() {
          tb.forEach((d) => {
            d.classList.remove("active");
          });
          item.classList.add("active");
          //hide them all -- radio__fieldset
          tbs.forEach((t) => {
            t.style.display = 'none';
          });
          //show the one you want -- radio__fieldset
          if (item.innerText == "EU") {
            rfneu.style.display = 'block';
            syncSizeToggle("eu");
          } else {
            var fs = dsls.querySelectorAll(".not-eu");
            fs.forEach((f) => {
              f.style.display = 'block';
            });
            syncSizeToggle("us");
          }
      }
    });
    //clicking the switch itself toggles to the other unit
    var swBtn = dsls.querySelector(".size-toggle__switch");
    if (swBtn) {
      swBtn.onclick = function() {
        var current = dsls.querySelector(".size-toggle__unit.active");
        tb.forEach((u) => { if (u !== current) { u.click(); } });
      };
    }
  }

  window.danskoSizeTabbing = window.danskoSizeTabbing || {};
  window.danskoSizeTabbing.mollie = initSizeTabbing;

  //PDP: run against the whole document, as this script always has.
  initSizeTabbing(document);
})();
